export const getLocalState = (state) => state.undoRedo
